import { FC } from 'react';
import * as React from 'react';

import { css } from 'styled-components';

import PencilOutline from '@crehana/icons/PencilOutline';
import PlaySquareOutline from '@crehana/icons/PlaySquareOutline';
import { Col, Row, Skeleton } from '@crehana/ui';
import { useUITheme } from '@crehana/web';

const CollapsedListSkeleton: FC<
  React.PropsWithChildren<{ 'data-testid'?: string }>
> = ({ 'data-testid': dataTestId }) => {
  const { isDark } = useUITheme();

  return (
    <Row gutter={24} data-testid={dataTestId}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Col key={`collapsed-header-skeleton-${i * 1}`}>
          <div
            className={`w-full h-full flex flex-col sm:flex-row ${
              isDark ? 'bg-base-lighter-8' : 'bg-white shadow-tooltip'
            }`}
            css={css`
              ${({ theme }) => theme.breakpoints.up('sm')} {
                height: 154px;
              }
            `}
          >
            <Skeleton
              className="w-full relative flex-shrink-0"
              css={css`
                padding-top: 69%;
                ${({ theme }) => theme.breakpoints.up('sm')} {
                  padding-top: 0;
                  width: 160px;
                }
                ${({ theme }) => theme.breakpoints.up('md')} {
                  width: 243px;
                }
              `}
              isDark={isDark}
            />
            <div className="w-full flex flex-col justify-center py-16 pl-16 sm:py-0 md:pl-24 pr-64 sm:pr-72 md:pr-80">
              <Skeleton
                className="w-full max-w-280 h-20 md:h-24 mb-8"
                isDark={isDark}
              />
              <div className="font-caption text-gray-dark flex items-center mb-4">
                <PlaySquareOutline
                  size={16}
                  ignoreColor
                  className="fill-current mr-8"
                />
                <Skeleton className="w-full max-w-144 h-16" isDark={isDark} />
              </div>
              <div className="font-caption text-gray-dark flex items-center">
                <PencilOutline
                  size={16}
                  ignoreColor
                  className="fill-current mr-8"
                />
                <Skeleton className="w-full max-w-144 h-16" isDark={isDark} />
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default CollapsedListSkeleton;
